export default {
  baseApi: process.env.VUE_APP_API,
  token: process.env.VUE_APP_TOKEN,
  passKey: process.env.VUE_APP_PASS_KEY,
  sendMessage: process.env.VUE_APP_SEND_MESSAGE,
  addressKey: process.env.VUE_APP_ADDRESS_KEY,
  productKey: process.env.VUE_APP_PRODUCT_KEY,
  honeKey: process.env.VUE_APP_HONE_KEY,
  communityKey: process.env.VUE_APP_COMMUNITY_KEY,

}



